import React, { ReactElement, useContext } from 'react';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { useTranslation } from 'react-i18next';

import { useAsyncEffect } from 'customHooks/hooks';
import { logger } from 'utils/logger';
import { ReportBuilderComponentProps } from 'screens/WidgetGenerator/reportGeneratorComponents/components/WidgetWrappers/WidgetWrappers';
import { ScoreTextWithSentimentBar } from 'screens/WidgetGenerator/widgets/ScoreTextWithSentimentBar/ScoreTextWithSentimentBar';

import { getQuestionScoreData } from 'screens/WidgetGenerator/helpers/questionsScore';
import { SelectOption } from '@zencity/common-ui/lib/ZCD/ZCDFilter/types';
import { SurveysReportGeneratorFilterKey } from '../enums';

export const ScoreTextWithSentimentBarHOC = (props: ReportBuilderComponentProps): ReactElement => {
  const { client, cycles, selectedDateRange, selectedSurveyGroup } = useContext(WidgetGeneratorContext);
  const { t: translate } = useTranslation();

  const { params } = props;
  const selectedQuestion = params.filters?.[
    SurveysReportGeneratorFilterKey.SERVICE_SENTIMENT_BAR_QUESTION_SELECT
  ] as SelectOption;

  const questionId = selectedQuestion?.value as number;

  const fetchServiceData = async () => {
    if (!questionId) {
      return null;
    }
    const fetchedServiceData = await getQuestionScoreData({
      client,
      cycles,
      selectedDateRange,
      selectedSurveyGroupId: selectedSurveyGroup.id,
      genericQuestionId: questionId,
    });
    return fetchedServiceData;
  };

  const {
    fetchedData: fetchedServiceData,
    isLoading,
    error,
  } = useAsyncEffect(fetchServiceData, [client, cycles, selectedDateRange, selectedQuestion]);

  if (error) {
    logger.error(error);
  }
  if (!fetchedServiceData) {
    return <p>{translate('widgetGenerator.widgets.serviceSentimentBar.emptyState')}</p>;
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <ScoreTextWithSentimentBar
        widgetData={fetchedServiceData}
        isBenchmarked
        showAllSatisfactionScores
        showSentimentBar
      />
    </LoaderMask>
  );
};
